function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tippy from '@tippy.js/react';
/**
 * A Tooltip extends the content of another element by providing additional content.
 * Its position and appearance can be customized.
 *
 * We use Tippy.js, a highly customizable tooltip and popover library
 * powered by Popper.js
 * https://atomiks.github.io/tippyjs/
 *
 * To see all props you can use: https://atomiks.github.io/tippyjs/all-options/
 *
 * @return {jsx}
 */

var Tooltip = function Tooltip(_ref) {
  var appearance = _ref.appearance,
      arrow = _ref.arrow,
      boundary = _ref.boundary,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      maxWidth = _ref.maxWidth,
      placement = _ref.placement,
      trigger = _ref.trigger,
      rest = _objectWithoutProperties(_ref, ["appearance", "arrow", "boundary", "children", "className", "content", "maxWidth", "placement", "trigger"]);

  return /*#__PURE__*/React.createElement(Tippy, _extends({
    arrow: arrow,
    className: "".concat(className, " ").concat(appearance),
    content: content,
    maxWidth: maxWidth,
    placement: placement,
    trigger: trigger,
    boundary: boundary
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex'
    }
  }, children));
};

var node = PropTypes.node,
    string = PropTypes.string;
Tooltip.propTypes = _objectSpread(_objectSpread({}, Tippy.propTypes), {}, {
  children: node,
  className: string
});
Tooltip.defaultProps = _objectSpread(_objectSpread({}, Tippy.defaultProps), {}, {
  arrow: true,
  boundary: 'window',
  children: null,
  placement: 'top',
  trigger: 'click'
});
export default styled(Tooltip).withConfig({
  displayName: "Tooltip",
  componentId: "kbkeez-0"
})(["border-radius:", ";padding:0.6rem 1rem;font-size:1.4rem;&[x-placement^='top']{.tippy-arrow{border-width:6px 6px 0 6px;bottom:-6px;}}&[x-placement^='bottom']{.tippy-arrow{border-width:0 6px 6px 6px;top:-6px;}}&[x-placement^='left']{.tippy-arrow{border-width:6px 0px 6px 6px;right:-6px;}}&[x-placement^='right']{.tippy-arrow{border-width:6px 6px 6px 0px;left:-6px;}}&.dark{color:", ";background:", ";&[x-placement^='top'],&[x-placement^='bottom']{.tippy-arrow{border-color:", " transparent ", " transparent;}}&[x-placement^='left'],&[x-placement^='right']{.tippy-arrow{border-color:transparent ", " transparent ", ";}}}&.light{color:", ";background:", ";box-shadow:0 0 0 1px ", ",0 2px 16px 0 rgba(0,0,0,0.1);&[x-placement^='top'],&[x-placement^='bottom']{.tippy-arrow{border-color:", " transparent ", " transparent;}}&[x-placement^='left'],&[x-placement^='right']{.tippy-arrow{border-color:transparent ", " transparent ", ";}}}"], function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.white;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.darkBlue;
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.darkBlue;
}, function (_ref6) {
  var palette = _ref6.theme.palette;
  return palette.darkBlue;
}, function (_ref7) {
  var palette = _ref7.theme.palette;
  return palette.darkBlue;
}, function (_ref8) {
  var palette = _ref8.theme.palette;
  return palette.darkBlue;
}, function (_ref9) {
  var palette = _ref9.theme.palette;
  return palette.darkBlue;
}, function (_ref10) {
  var palette = _ref10.theme.palette;
  return palette.white;
}, function (_ref11) {
  var palette = _ref11.theme.palette;
  return palette.lightGrey;
}, function (_ref12) {
  var palette = _ref12.theme.palette;
  return palette.white;
}, function (_ref13) {
  var palette = _ref13.theme.palette;
  return palette.white;
}, function (_ref14) {
  var palette = _ref14.theme.palette;
  return palette.white;
}, function (_ref15) {
  var palette = _ref15.theme.palette;
  return palette.white;
});